var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 7.25C12.6562 7.25 13.5 8.09375 13.5 9.125C13.5 10.2031 12.6562 11 11.625 11H8.25V7.25H11.625ZM18 0.5C19.6406 0.5 21 1.85938 21 3.5V18.5C21 20.1875 19.6406 21.5 18 21.5H3C1.3125 21.5 0 20.1875 0 18.5V3.5C0 1.85938 1.3125 0.5 3 0.5H18ZM11.625 13.25C13.875 13.25 15.75 11.4219 15.75 9.125C15.75 6.875 13.875 5 11.625 5H7.125C6.46875 5 6 5.51562 6 6.125V15.875C6 16.5312 6.46875 17 7.125 17C7.73438 17 8.25 16.5312 8.25 15.875V13.25H11.625Z",
    fill: "#1D4F8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.545d69d992cfe9c6819541d006a14fc4.svg";
export { ForwardRef as ReactComponent };